const regexp = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

export default function (email) {
    if (!email) return false;

    if (email.length > 254) return false;

    const valid = regexp.test(email);
    if (!valid) return false;

    // Check that no single part exceeds 64 characters in length, as we didn't check for that in the regex above.
    const parts = email.split('@');
    if (parts[0].length > 64) return false;

    const domainParts = parts[1].split('.');
    return !domainParts.some((part) => part.length > 63);
}



// WEBPACK FOOTER //
// ./src/components/helpers/validation/validateEmail.js